export const LIST_TEXT_TEMPLATE_REQUEST = 'LIST_TEXT_TEMPLATE_REQUEST'
export const LIST_TEXT_TEMPLATE_SUCCESS = 'LIST_TEXT_TEMPLATE_SUCCESS'
export const LIST_TEXT_TEMPLATE_FAIL = 'LIST_TEXT_TEMPLATE_FAIL'

export const LIST_TEXT_TEMPLATE_SUMMARY_REQUEST = 'LIST_TEXT_TEMPLATE_SUMMARY_REQUEST'
export const LIST_TEXT_TEMPLATE_SUMMARY_SUCCESS = 'LIST_TEXT_TEMPLATE_SUMMARY_SUCCESS'
export const LIST_TEXT_TEMPLATE_SUMMARY_FAIL = 'LIST_TEXT_TEMPLATE_SUMMARY_FAIL'

export const CREATE_TEXT_TEMPLATE_REQUEST = 'CREATE_TEXT_TEMPLATE_REQUEST'
export const CREATE_TEXT_TEMPLATE_SUCCESS = 'CREATE_TEXT_TEMPLATE_SUCCESS'
export const CREATE_TEXT_TEMPLATE_FAIL = 'CREATE_TEXT_TEMPLATE_FAIL'

export const DETAIL_TEXT_TEMPLATE_REQUEST = 'DETAIL_TEXT_TEMPLATE_REQUEST'
export const DETAIL_TEXT_TEMPLATE_SUCCESS = 'DETAIL_TEXT_TEMPLATE_SUCCESS'
export const DETAIL_TEXT_TEMPLATE_FAIL = 'DETAIL_TEXT_TEMPLATE_FAIL'

export const UPDATE_TEXT_TEMPLATE_REQUEST = 'UPDATE_TEXT_TEMPLATE_REQUEST'
export const UPDATE_TEXT_TEMPLATE_SUCCESS = 'UPDATE_TEXT_TEMPLATE_SUCCESS'
export const UPDATE_TEXT_TEMPLATE_FAIL = 'UPDATE_TEXT_TEMPLATE_FAIL'

export const DELETE_TEXT_TEMPLATE_REQUEST = 'DELETE_TEXT_TEMPLATE_REQUEST'
export const DELETE_TEXT_TEMPLATE_SUCCESS = 'DELETE_TEXT_TEMPLATE_SUCCESS'
export const DELETE_TEXT_TEMPLATE_FAIL = 'DELETE_TEXT_TEMPLATE_FAIL'

export const RESET_TEXT_TEMPLATE = 'RESET_TEXT_TEMPLATE'